import { Button } from 'devextreme-react/button'
import React, {useState, useImperativeHandle, forwardRef, useEffect} from "react";
import notify from "devextreme/ui/notify";
import {FileUploader} from "devextreme-react";
import {useAuth} from "../../contexts/auth";
import './file-uploader.scss'
//import routes from "../../app-routes";

const ExtFileUploader = forwardRef((props, ref) => {
    const { fileLimits } = useAuth()
    const [attachFilesExt, setAttachFilesExt] = useState([])
    const fileLimit = fileLimits[props.typeFileLimit || 'req' ]
    const disabledUploader = props.disabledForms || false
    const maxLengthFileName = props.maxLengthFileName || 255
    const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt';
    const [filesTxt, setFilesTxt] = useState('файл')

    useImperativeHandle(ref, () => ({
        clearAttachFiles() {
            setAttachFilesExt([])
        }
    }));

    useEffect( () => {
        (async function () {
            setAttachFilesExt([])
        })()
    }, [props.selectedReqId])

    useEffect( () => {
        (async function () {
            let n = Math.abs(fileLimit?.maxCountFiles);
            const lastDigit = n % 10;
            const lastTwoDigits = n % 100;
            let word;
            if (lastTwoDigits >= 11 && lastTwoDigits <= 19) word = 'файлов, каждый ';
            else if (lastDigit === 1) word = 'файл, ';
            else if (lastDigit >= 2 && lastDigit <= 4) word = 'файла, каждый ';
            else word = 'файлов, каждый ';
            setFilesTxt(word)
        })()
    }, [fileLimit?.maxCountFiles])

    let shiftNotify = 0
    const onOptionChanged = (e) => {
        // shift накопительный для сдвига нотифера
        if(e.fullName !== "value") return;

        if (envTat) {
            // проверка на превышение длины имени файла с выводом сообщения (только ТЭС)
            let bigFilesName = []
            e.value = e.value.filter( e => {
                if (e.name.length <= +maxLengthFileName) {
                    return e;
                } else {
                    bigFilesName.push( e );
                    return false;
                }
            } )
            if (bigFilesName.length > 0) {
                notifyShift( `Файлы с длиной имени свыше ${maxLengthFileName} символа: ${bigFilesName.length} шт. не были подключены.`, 'info' );
            }
        }
        // проверка на превышение размера с выводом сообщения
        let bigFiles = []
        let smallFiles = e.value.filter(e => {
            if (e.size <= +fileLimit?.maxFileSize){
                return e;
            } else {
                bigFiles.push(e);
                return false;
            }
        })
        if (bigFiles.length > 0) {
            notifyShift(`Файлы свыше ${fileLimit.maxFileSizeTxt}: ${bigFiles.length} шт. не были подключены.`, 'info');
        }
        e.value = smallFiles
        // проверяем расширения
        if (fileLimit.acceptExtTxt.split(',')[0] !== '*') {
            let notExtFiles = []
            let extFiles = e.value.filter(e => {
                let ext = e.name.slice(e.name.lastIndexOf('.'))
                if (fileLimit.acceptExtTxt.split(',').includes(ext.toLowerCase())) {
                    return e;
                } else {
                    notExtFiles.push(e)
                    return false;
                }
            })
            if (notExtFiles.length > 0) {
                notifyShift(`Не подходит расширение файлов: ${notExtFiles.length} шт. не были подключены.`, 'info');
            }
            e.value = extFiles
        }

        // объединение с откидыванием дубликатов
        let result = []
        if(e.previousValue.length !== 0 && e.value.length >= e.previousValue.length) {
            result = Array.from([...e.previousValue, ...e.value]
                .reduce((m, o) => m.set(o.name, o), new Map())
                .values()
            );

        } else if (e.previousValue.length === 0 || e.value.length < e.previousValue.length){
            result = e.value
        }
        // собщение о превышении количества и сокращение массива
        if (result.length > fileLimit.maxCountFiles) {
            result.length = fileLimit.maxCountFiles
            notifyShift(`Максимум файлов ${fileLimit.maxCountFiles}. Количество файлов сокращено до ${fileLimit.maxCountFiles} шт.`,"success")
        }

        setAttachFilesExt(result)

        // удаление файлов из списка для татэнерго на форме add-dogovor. Добавляем delfiles = true (удаление по одному)
        const delFiles = e.previousValue.filter(file => !e.value.map(filenew => filenew.name).includes(file.name))
        if (delFiles.length > 0 && process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'){
            delFiles.map(e => e.delfiles = true)
            result = [...result, ...delFiles]
        }
        props.setfile(result)
        shiftNotify = 0
    }

    // нотификатор при проверке файлов автоматом сдвигает по вертикали мессаги
    const notifyShift = (message, type) => {
        notify({
            message: message,
            type: type,
            displayTime: 6000,
            position: {
                at: "bottom",
                my: "center",
                of: window,
                offset: { x: 0 , y: - 50 + shiftNotify}
            }
        })
        shiftNotify -= 60
    }

    const onClickClearUpload = (files) =>{
        setAttachFilesExt([])
        if (props.onClickClearUpload) props.onClickClearUpload()
        // удаление файлов из списка для татэнерго на форме add-dogovor. Добавляем delfiles = true (удаление всех)
        if (process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' && window.location.hash === '#/add-dogovor/tat'){
            files.filter(e => e.delfiles !== true).map(f => f.delfiles = true)
            props.setfile(files)
            return
        }
        props.setfile([])
    }





    return (
        <>
            <FileUploader disabled={disabledUploader || +fileLimit?.maxCountFiles === attachFilesExt.length}
                multiple={fileLimit?.maxCountFiles > 1}
                uploadMode={'useButtons'}
                value={attachFilesExt}
                onOptionChanged={onOptionChanged}
                dataField="attachments"
                selectButtonText={"Выберите файлы"}
                labelText= {"Или перетащите файлы сюда"}
                maxFileSize= {+fileLimit?.maxFileSize}
                //allowedFileExtensions={['.log']}
                accept={fileLimit?.acceptExtTxt}
            />
            {attachFilesExt.length > 0 &&
                <>
                    <Button text="Очистить список загрузки"  onClick={() => onClickClearUpload(attachFilesExt)} style={{textDecorationStyle:"dashed"}} /><br/><br/>
                </>
            }
            {fileLimit?.acceptExtTxt?.length>0 && fileLimit?.acceptExtTxt[0] !== '*' &&
            <>
                <span className="note">{'Разрешены: '}
                <span>{fileLimit?.acceptExtTxt.replaceAll(",", ", ")}</span>.
                                </span><br/>
            </>
            }
                <span className="note">{'Ограничение: '}
                <span>{fileLimit?.maxCountFiles}</span> {filesTxt}не более <span>{fileLimit?.maxFileSizeTxt}</span>.
                                </span>

        </>
    )
});


export default ExtFileUploader

